"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _Text = _interopRequireDefault(require("../text/Text"));

var _Layout = _interopRequireDefault(require("../layout/Layout"));

var _ChevronButton = _interopRequireDefault(require("../button/ChevronButton"));

var _StaggeredFadeIn = _interopRequireDefault(require("../effect/animation/StaggeredFadeIn"));

var _providers = require("../../toolkit/providers");

//
//  src/nav/Accordion.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/12/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */
var demoProps = {
  header: "Tax for Germany"
};
var DEFAULT_CHEVRON_LOCATION = "left";
var propDoc = {
  header: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "Title of the section. Can be either a " + "string or a custom render"
  },
  centerHeader: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates whether to center the header"
  },
  headerPadding: {
    required: false,
    type: "string",
    defaultValue: "10px 15px",
    description: "Padding of the header container"
  },
  description: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "Description of the section. Rendered beneath the title"
  },
  isOpen: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the section is open/expanded"
  },
  chevronSize: {
    required: false,
    defaultValue: "16",
    type: "number",
    description: "Optional indicator of the size of the " + "section's Chevron button"
  },
  hideChevron: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the expand button should be hidden"
  },
  hideLines: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the lines should be hidden"
  },
  backgroundColor: {
    required: false,
    defaultValue: "rgba(238, 242, 245, 0.5)",
    type: "string",
    description: "Override the background color of the content"
  },
  onOpenToggled: {
    required: false,
    defaultValue: "null",
    type: "(isOpen: boolean) => mixed",
    description: "Callback for when the section is toggled open and shut"
  },
  chevronLocation: {
    required: false,
    defaultValue: DEFAULT_CHEVRON_LOCATION,
    type: "left | right",
    description: "Location of the chevron (arrow) in the header"
  },
  headerContainerStyle: {
    required: false,
    defaultValue: "any",
    type: "CSSProperties",
    description: "Style of the Accordion header"
  }
};
var demoRender = "\n<Card>\n<Accordion\n  header=\"Tax for Germany\"\n  onOpenToggled={(isOpen) => {}}\n  isOpen\n>\n  <div style={{ padding: \"20px 30px\" }}>\n    Sola\n  </div>\n</Accordion>\n</Card>\n";

var Accordion = function Accordion(props) {
  var _props$isOpen = props.isOpen,
      isOpen = _props$isOpen === void 0 ? false : _props$isOpen,
      _props$hideChevron = props.hideChevron,
      hideChevron = _props$hideChevron === void 0 ? false : _props$hideChevron,
      _props$chevronLocatio = props.chevronLocation,
      chevronLocation = _props$chevronLocatio === void 0 ? DEFAULT_CHEVRON_LOCATION : _props$chevronLocatio,
      children = props.children;
  var styles = useStylesheet(props);
  var foldable = _react["default"].Children.count(children) > 0;
  var showChevron = foldable && !hideChevron;
  var style = props.style,
      className = props.className,
      centerHeader = props.centerHeader,
      headerContainerStyle = props.headerContainerStyle;
  return /*#__PURE__*/_react["default"].createElement(_Layout["default"].FlexColumn, {
    className: (0, _styling.css)(styles.root, style, className),
    alignItems: "stretch"
  }, /*#__PURE__*/_react["default"].createElement(_Layout["default"].FlexRow, {
    className: (0, _styling.css)(styles.headerContainer, headerContainerStyle),
    justifyContent: centerHeader ? "center" : "flex-start"
  }, showChevron && chevronLocation === "left" && /*#__PURE__*/_react["default"].createElement(Chevron, props), /*#__PURE__*/_react["default"].createElement(HeaderContent, props), showChevron && chevronLocation === "right" && /*#__PURE__*/_react["default"].createElement(Chevron, props)), foldable && isOpen && /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
    deltaY: -5,
    animationDurationMs: 400
  }, /*#__PURE__*/_react["default"].createElement(_Layout["default"].FlexColumn, {
    className: (0, _styling.css)(styles.contentContainer)
  }, children)));
};

var Chevron = function Chevron(props) {
  var onOpenToggled = props.onOpenToggled,
      isOpen = props.isOpen,
      _props$chevronSize = props.chevronSize,
      chevronSize = _props$chevronSize === void 0 ? 12 : _props$chevronSize;
  return /*#__PURE__*/_react["default"].createElement(_ChevronButton["default"], {
    direction: isOpen ? "down" : "right",
    size: chevronSize,
    onClick: function onClick() {
      if (onOpenToggled != null) {
        onOpenToggled(!isOpen);
      }
    }
  });
};

var HeaderContent = function HeaderContent(props) {
  var onOpenToggled = props.onOpenToggled,
      isOpen = props.isOpen,
      description = props.description,
      header = props.header;
  var styles = useStylesheet(props);

  if (typeof header === "string") {
    return /*#__PURE__*/_react["default"].createElement(_Layout["default"].FlexColumn, {
      onClick: function onClick() {
        if (onOpenToggled != null) {
          onOpenToggled(!isOpen);
        }
      },
      className: (0, _styling.css)(styles.titleContainer)
    }, header && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      weight: "bold",
      className: (0, _styling.css)(styles.titleText)
    }, header), description && /*#__PURE__*/_react["default"].createElement(_Text["default"], null, description));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header());
};

Accordion.propDoc = propDoc;
Accordion.demoProps = demoProps;
Accordion.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(Accordion);

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var hideLines = _ref.hideLines,
      isOpen = _ref.isOpen,
      headerPadding = _ref.headerPadding,
      onOpenToggled = _ref.onOpenToggled,
      backgroundColor = _ref.backgroundColor;

  var _useTheme = (0, _providers.useTheme)(),
      borderPrimary = _useTheme.borderPrimary,
      surfaceLight = _useTheme.surfaceLight,
      surfaceLightest = _useTheme.surfaceLightest;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        borderBottom: !hideLines && isOpen ? "1px solid ".concat(borderPrimary) : undefined
      },
      contentContainer: {
        display: "flex",
        flexSirection: "column",
        backgroundColor: backgroundColor || "".concat(surfaceLight, "80")
      },
      headerContainer: {
        padding: headerPadding || "7px 10px",
        borderBottom: !hideLines ? "1px solid ".concat(borderPrimary) : undefined,
        backgroundColor: surfaceLightest
      },
      titleContainer: {
        display: "flex",
        flexDirection: "column",
        cursor: onOpenToggled == null ? "default" : "pointer",
        flex: 1
      },
      titleText: {
        fontSize: 16,
        lineHeight: 1.24,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      },
      titleDescription: {
        fontSize: 16,
        lineHeight: 1.5,
        cursor: "default"
      }
    });
  }, [hideLines, isOpen, headerPadding, onOpenToggled, backgroundColor, borderPrimary, surfaceLight, surfaceLightest]);
};